<template>
  <div class='NaveProdMobile'>
    <SelectCateg/>
    <div class="c-filter">
      <div :class="{ focus: FilterProdPainel.status }" class="c-filter-btn" @click="getFilter(true)">
        Publicado ({{ ProdutoStatus.publicados }})
      </div>
      <div :class="{ focus: !FilterProdPainel.status }" class="c-filter-btn" @click="getFilter(false)">
        Arquivado ({{ ProdutoStatus.arquivados }})
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SelectCateg from './SelectCateg'
export default {
  name: 'NaveProdMobile',
  components: { SelectCateg },
  computed: {
    ...mapGetters(['Produtos', 'FilterProdPainel', 'ProdutoStatus'])
  },
  methods: {
    ...mapActions(['changeFilterProdPainel', 'GetProduct', 'Loading', 'GetProdutoStatus']),
    getFilter (status) {
      this.changeFilterProdPainel({ status: status })
        .then(() => {
          this.Loading(true)
          this.GetProduct({ params: { last: 0, limit: 15, categoria: this.FilterProdPainel.categoria, status: this.FilterProdPainel.status }, init: true })
            .then(res => {
              this.produtos = res
              this.Loading(false)
            })
        })
    }
  },
  created () {
    this.GetProdutoStatus(0)
    this.GetProdutoStatus(1)
  }
}
</script>

<style scoped>
.NaveProdMobile {
}

.c-filter {
  display: flex;
  padding: 1.5%;
}

.c-filter-btn {
  color: #000000;
  padding: 3%;
  width: 49%;
  margin: 1%;
  border: thin solid #CCCCCC;
  border-radius: 5px;
  background-color: #EEEEEE;
}

.focus {
  background-color: #FFFFFF;
}

@media screen and (min-width: 500px) {
  .NaveProdMobile {
    display: none;
  }
}
</style>
